import React, { useMemo } from 'react'
import Seo from '../Seo'

const env = (typeof process !== 'undefined' && process.env) || {}

const DEFAULTS = {
  embedUrl: 'https://app.leanit101.com/benjamin',
  embedToken:
    'eyJvcmdhbml6YXRpb25JZCI6NDMsImFnZW50U2x1ZyI6ImV2b2x1Y2Npb25hcmUtc2FsZXMtYXNzaXN0YW50IiwidGVuYW50U2x1ZyI6ImV2b2x1Y2Npb25hcmUiLCJhc3Npc3RhbnROYW1lIjoiRXZhIiwiZ3JlZXRpbmdzIjp7ImVuIjoiSGksIEknbSBFdmEgZnJvbSBFdm9sdWNjaW9uYXJlLiBUZWxsIG1lOiB3aGF0J3MgdGhlIG1haW4gcGVvcGxlLCBsZWFkZXJzaGlwLCBvciBjdWx0dXJlIGNoYWxsZW5nZSB5b3Ugd2FudCB0byBhZGRyZXNzIHRvZGF5PyIsImVzIjoiSG9sYSwgc295IEV2YSBkZSBFdm9sdWNjaW9uYXJlLiBDdcOpbnRhbWU6IMK_Y3XDoWwgZXMgZWwgcHJpbmNpcGFsIGRlc2Fmw61vIGRlIHBlcnNvbmFzLCBsaWRlcmF6Z28gbyBjdWx0dXJhIHF1ZSBxdWllcmVuIHJlc29sdmVyIGhveT8iLCJwdCI6Ik9sw6EsIGV1IHNvdSBhIEV2YSwgZGEgRXZvbHVjY2lvbmFyZS4gTWUgY29udGE6IHF1YWwgw6kgbyBwcmluY2lwYWwgZGVzYWZpbyBkZSBwZXNzb2FzLCBsaWRlcmFuw6dhIG91IGN1bHR1cmEgcXVlIHZvY8OqIHF1ZXIgcmVzb2x2ZXIgaG9qZT8ifSwibWV0YWRhdGEiOnsiY2hhbm5lbERlZmF1bHQiOiJ3ZWJfZW1iZWQiLCJkZWZhdWx0TG9jYWxlIjoicHQtQlIifX0.352e9c02673883b938b6e0012505a08637341cd9878af3125ddaedbf5cec6575',
  agentSlug: 'evoluccionare-sales-assistant',
  tenantSlug: 'evoluccionare',
  organizationId: '43',
  assistantName: 'Eva',
  channel: 'web_embed',
  utmSource: 'leanit101.com',
  utmCampaign: 'evoluccionare-sales-poc',
}

const EvoluccionareSalesPage = () => {
  const queryParams = useMemo(() => {
    if (typeof window === 'undefined') return new URLSearchParams('')
    return new URLSearchParams(window.location.search || '')
  }, [])

  const embedToken =
    queryParams.get('token') ||
    env.REACT_APP_EVOLUCCIONARE_EMBED_TOKEN ||
    DEFAULTS.embedToken

  const agentSlug =
    queryParams.get('agentSlug') ||
    env.REACT_APP_EVOLUCCIONARE_AGENT_SLUG ||
    DEFAULTS.agentSlug

  const tenantSlug = (
    queryParams.get('tenantSlug') ||
    env.REACT_APP_EVOLUCCIONARE_TENANT_SLUG ||
    DEFAULTS.tenantSlug
  )
    .toString()
    .trim()
    .toLowerCase()

  const organizationId =
    queryParams.get('organizationId') ||
    env.REACT_APP_EVOLUCCIONARE_ORGANIZATION_ID ||
    DEFAULTS.organizationId

  const assistantName =
    queryParams.get('assistantName') ||
    env.REACT_APP_EVOLUCCIONARE_ASSISTANT_NAME ||
    DEFAULTS.assistantName

  const channel = queryParams.get('channel') || DEFAULTS.channel
  const utmSource = queryParams.get('utm_source') || DEFAULTS.utmSource
  const utmCampaign = queryParams.get('utm_campaign') || DEFAULTS.utmCampaign

  const iframeSrc = useMemo(() => {
    const params = new URLSearchParams()
    if (embedToken) params.set('token', embedToken)
    params.set('agentSlug', agentSlug)
    params.set('tenantSlug', tenantSlug)
    params.set('organizationId', organizationId)
    params.set('assistantName', assistantName)
    params.set('channel', channel)
    params.set('locale', 'pt-BR')
    if (utmSource) params.set('utm_source', utmSource)
    if (utmCampaign) params.set('utm_campaign', utmCampaign)
    params.set('meta.source', 'evoluccionare-sales-poc')
    params.set('meta.partner', 'evoluccionare')

    const baseUrl =
      env.REACT_APP_EVOLUCCIONARE_EMBED_URL || DEFAULTS.embedUrl
    return `${baseUrl}?${params.toString()}`
  }, [
    agentSlug,
    assistantName,
    channel,
    embedToken,
    organizationId,
    tenantSlug,
    utmCampaign,
    utmSource,
  ])

  return (
    <section className="relative flex min-h-screen w-full flex-col overflow-hidden bg-[#07110f] text-white">
      <Seo
        title="Evoluccionare | Eva"
        description="POC privada para validar a Eva, agente de qualificação da Evoluccionare."
        path="/evoluccionare-sales"
        noindex
      />

      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-[#10211d] via-[#07110f] to-[#07110f]" />
        <div
          className="absolute left-[8%] top-[-180px] h-[660px] w-[660px] rounded-full opacity-28"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(114,190,160,0.28) 0%, rgba(114,190,160,0) 70%)',
            filter: 'blur(58px)',
          }}
        />
        <div
          className="absolute bottom-[-220px] right-[-120px] h-[580px] w-[580px] rounded-full opacity-18"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(214,189,136,0.22) 0%, rgba(214,189,136,0) 66%)',
            filter: 'blur(50px)',
          }}
        />
        <div
          className="absolute inset-0 opacity-[0.06]"
          style={{
            backgroundImage:
              'linear-gradient(to right, rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.06) 1px, transparent 1px)',
            backgroundSize: '30px 30px',
          }}
        />
      </div>

      <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 px-4 py-12 md:py-16">
        <header className="space-y-4 text-center">
          <p className="text-xs uppercase tracking-[0.42em] text-[#9ee3ca]/76">
            Evoluccionare
          </p>
          <h1 className="text-3xl font-semibold md:text-5xl">
            Eva • qualificação humana para cultura, liderança e bem-estar
          </h1>
          <p className="mx-auto max-w-3xl text-base text-slate-200 md:text-lg">
            Página de POC para validar a Eva como ponto inicial de conversa com
            leads que chegam com desafios de cultura, liderança, saúde mental,
            riscos psicossociais e evolução organizacional.
          </p>
        </header>

        <div className="grid gap-6 lg:grid-cols-[1.1fr_minmax(320px,0.9fr)]">
          <div className="w-full overflow-hidden rounded-[28px] border border-[#9ee3ca]/12 bg-[#0d1715]/75 shadow-2xl">
            <div className="border-b border-white/8 px-5 py-4">
              <div className="text-[11px] uppercase tracking-[0.34em] text-[#9ee3ca]/70">
                Conversa ao vivo
              </div>
              <div className="mt-2 text-sm text-slate-300">
                Fluxo em português voltado para entender o contexto da empresa,
                identificar o principal desafio humano do momento e encaminhar o
                lead para a trilha mais aderente dentro da Evoluccionare.
              </div>
            </div>
            <div className="relative h-[560px] w-full md:h-[660px]">
              <iframe
                title="Evoluccionare — Eva"
                src={iframeSrc}
                allow="clipboard-read; clipboard-write"
                className="absolute inset-0 h-full w-full"
                style={{ background: 'transparent', border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          <div className="grid content-start gap-4">
            <div className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-[#9ee3ca]/78">
                Posicionamento
              </div>
              <h2 className="mt-3 text-xl font-semibold">
                Acolhimento consultivo com clareza comercial
              </h2>
              <p className="mt-3 text-sm leading-6 text-slate-200">
                A Eva foi configurada para soar humana, perceptiva e confiável,
                sem virar formulário em chat e sem cair em discurso terapêutico.
                A meta é captar contexto suficiente para qualificar bem e
                encaminhar com precisão para o time.
              </p>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-[#9ee3ca]/78">
                O que observar
              </div>
              <ul className="mt-3 space-y-3 text-sm leading-6 text-slate-200">
                <li>Se a Eva entende rápido o desafio principal sem reproduzir um formulário inteiro.</li>
                <li>Se ela diferencia bem temas de NR-1, cultura, liderança, saúde mental e capacitação interna.</li>
                <li>Se o tom parece humano, seguro e comercialmente útil em vez de robótico ou excessivamente genérico.</li>
                <li>Se o encaminhamento para próximo passo acontece com contexto suficiente e sem over-qualification.</li>
              </ul>
            </div>

            <div className="rounded-2xl border border-[#d6bd88]/18 bg-[#101816] p-5">
              <div className="text-[11px] uppercase tracking-[0.3em] text-[#d6bd88]/82">
                Compartilhamento
              </div>
              <p className="mt-3 text-sm leading-6 text-slate-200">
                Use este link com o cliente para validação da POC:
              </p>
              <code className="mt-3 block break-all text-xs text-[#f0e1b2] md:text-sm">
                https://leanit101.com/evoluccionare-sales
              </code>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-[#9ee3ca]/78">
                Contexto da POC
              </div>
              <p className="mt-3 text-sm leading-6 text-slate-200">
                Esta página envia o embed com <strong>organizationId 43</strong>,
                locale <strong>pt-BR</strong> e metadados específicos da POC da
                Evoluccionare, voltada para qualificação inicial de demandas
                ligadas a cultura, liderança, saúde mental e riscos
                psicossociais.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default EvoluccionareSalesPage
